import React, { memo, useEffect, useRef, useState } from "react";
import clsx from "clsx";

import HeaderPage from "../../components/HeaderPage/Index";
import Loading from "../../components/loading/loading";
import {
  checkEditPage,
  clearData,
  getAllCountry,
  getAllStorage,
  getData,
  storeData,
} from "../../utils/GlobalHelper";
import { isMobile } from "react-device-detect";
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import ButtonRight from "../../components/BoxRightContent/ButtonRight";
import DialogCustoms from "../../components/CustomDialog/DialogCustoms";
import MoreInfo from "../../components/Modal/MoreInfo";
import Configs from "../../constants/Configs";

import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  TextField,
  Typography,
  Radio,
  RadioGroup,
  Checkbox,
  Box,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CancelIcon from "@mui/icons-material/Cancel";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import { ThemeProvider } from "@mui/material/styles";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { createTheme } from "@mui/material/styles";

import HeaderRight from "../../components/BoxRightContent/HeaderRight";
import ScrollBarComponent from "../../components/BoxRightContent/ScrollBarComponent";
import SuccessAlert from "../../components/Alert/SuccessAlert";
import ErrorAlert from "../../components/Alert/ErrorAlert";
import styles from "./Crs.module.css";
import alertStyles from "../../components/Alert/Alert.module.css";

const theme = createTheme({
  palette: {
    primary: {
      main: "#003D68",
      accent: "#A7A9AC",
    },
    secondary: {
      main: "#739CD8",
    },
  },
});

import {
  CRSData,
  CRSEditData,
  CRSRadioChecked,
  Idc,
  DeleteFlag,
  EditFlag,
  IsMoreInfo,
  CRSDeclareLocationKey,
  CRSUnSaveRadioCheck,
  HeaderManpKey,
  CRSBirthAddressKey,
} from "../../utils/GlobalKey";
import { isEmpty, isEqual } from "lodash";
import GlobalApi from "../../utils/GlobalApi";
const DataKey = CRSDeclareLocationKey;
const EditKey = CRSEditData;
const IdCardKey = Idc;
const CrsRadioKey = CRSUnSaveRadioCheck;
const CRSDeclareLocation = (props) => {
  const translations = getData("Translations");
  const [isLoading, setIsLoading] = useState(false);
  const [enableNextButton, setIsEnableNextButton] = useState(false);
  const [lang, setLang] = useState(getData("lang"));
  const [enableRadioButton, setEnableRadioButton] = useState(true);
  const [value, setValue] = useState("");
  const [crsFormData, setFormCrsData] = useState([]);
  const [isModel, setIsModel] = useState(false);
  const [alertShow, setAlertShow] = useState(0);
  const [isMoreInfo, setIsMoreInfo] = useState(getData(IsMoreInfo));
  const [defaultCountry, setDefaultCountry] = useState({
    countryId: "",
    country: "",
    taxNumber: "",
    checkNotax: false,
    notaxId: 0,
    notaxId2Text: "",
  });
  const [radioList] = useState([
    {
      id: true,
      name: "ใช่",
      isSelected: false,
    },
    {
      id: false,
      name: "ไม่ใช่",
      isSelected: false,
    },
  ]);
  const checkuserinfo = getData("checkuserinfo");
  const [jumpPage, setJumpPage] = useState(false);
  const checkJumpPage = async () => {
    const questions = getData("questionsAnswer");
    const pageAgree = getData("page_agree");
    // const snapIdCard = getData("uploadImage");
    const idc = getData(Idc);
    if (
      isEmpty(checkuserinfo) ||
      isEmpty(questions) ||
      isEmpty(pageAgree) ||
      pageAgree.termandcon !== 1 ||
      pageAgree.pdpa !== 1 ||
      isEmpty(idc)
    ) {
      return true;
    } else {
      return false;
    }
  };
  const [editUrl, setEditUrl] = useState(false);

  const [isModalError, setIsModalError] = useState(false);
  const [modalErrorTitle, setModalErrorTitle] = useState("ขออภัย");
  const [modalErrorDes, setModalErrorDes] = useState(
    "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง",
  );
  const [openModal, setOpenModal] = useState(false);

  // check edit Page
  const checkEditUrl = async () => {
    checkEditPage().then(async (res) => {
      setEditUrl(res);

      if (res) {
        // disable radio button
        setEnableRadioButton(false);
      }

      if (!getData(DataKey)) {
        const crsData = getData(CRSData);
        storeData(DataKey, crsData);
      }
      if (!getData(CrsRadioKey)) {
        const radioCheck = getData(CRSRadioChecked);
        storeData(CrsRadioKey, radioCheck);
      }
    });
  };

  const info = {
    title:
      "การยืนยันและการเปลี่ยนแปลงสถานะและ\n การเปิดเผยข้อมูลและความ\nยินยอมในการหักเงินใน",
    details:
      "ท่านยืนยันว่าข้อความข้างต้นเป็นความจริง ครบถ้วน ถูกต้องและเป็นปัจจุบัน You confirm that this information is true, complete, accurate and current...rhoncus feugiat faucibus bibendum. Neque netus sed nam mauris eget quisque non. Vivamus vulputate urna nibh morbi egestas arcu cursus at. Nullam in sit nisi accumsan risus nunc feugiat. Sapien fermentum pellentesque blandit elementum lorem ac volutpat orci pretium. Tristique at in a lectus auctor proin duis volutpat massa. Tempus lacus elit eu mauris nunc sed. Ac sed blandit in proin lacus ullamcorper tempus a. Placerat posuere neque sed orci a mauris sit. Morbi leo enim adipiscing sed risus enim sit ultrices. Viverra mauris magna nec aliquam tellus nec felis. Ultrices non purus cras vel aliquam at. Habitant pulvinar dictumst a accumsan interdum molestie vitae interdum. Ante bibendum leo ornare sed in aliquet ornare aliquet. Ultrices viverra posuere ac purus curabitur gravida arcu aliquet est. Gravida enim suscipit purus dis et aliquet quisque neque at. Dolor vulputate mi tempor viverra. Sapien pretium amet ut purus felis lectus orci senectus. Quis nunc dignissim at elit facilisi molestie arcu ultrices. Ac sed blandit in proin lacus ullamcorper tempus a. Placerat posuere neque sed orci a mauris sit.",
    btnText: "ถัดไป",
  };

  const getCountrys = async () => {
    clearData(EditKey);
    setIsLoading(true);
    try {
      let crsData = [];
      const idcStorage = getData(IdCardKey);
      let crsAddedData = getData(DataKey);
      if (crsAddedData) {
        crsData = crsAddedData;
      }

      if (!crsAddedData) {
        //เข้ามาครั้งแรก Default ไทย
        await getAllCountry()
          .then((res) => {
            setIsLoading(false);

            const thaiData = res.find((country) => country.ThName == "ไทย");

            if (crsData.length === 0) {
              crsData.push({
                ...defaultCountry,
                country: thaiData.ThName,
                countryId: thaiData.Id,
                taxNumber: idcStorage.idCard,
              });
            }
            setFormCrsData(crsData);
            storeData(DataKey, crsData);
          })
          .catch((err) => {
            console.log("err:", err);
            setIsLoading(false);
          });
      } else {
        storeData(DataKey, crsData);
        setFormCrsData(crsData);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
    return;
  };

  const handleNextButton = async () => {
    if (!value) {
      return;
    }

    if (value === "ไม่ใช่") {
      setIsModel(true);
      return;
    }

    const crsData = getData(DataKey);

    if (!crsData) {
      return;
    }

    if (value === "ใช่" && crsData.length == 0) {
      return;
    }

    if (editUrl) {
      //Edit: Call Update data -> Back to Summary
      setIsLoading(true);
      let isSuccesAll = false;
      const body = setTextSummary();
      const isSuccess = await postData(body);
      if (isSuccess) {
        const updateData = getData(DataKey);
        //store crs data list
        storeData(CRSData, updateData);
        const isSaveComeback = await saveComeBack();
        isSuccesAll = isSaveComeback;
      }
      setIsLoading(false);

      if (isSuccesAll) {
        props.history.goBack();
      }
    } else {
      const currentData = getData(DataKey);
      //store crs data list and radio selected
      storeData(CRSData, currentData);
      storeData(CRSRadioChecked, value === "ใช่");
      // navigate to CRS Consent
      props.history.push("/crs_consent");
    }
  };

  const setTextSummary = () => {
    const headToken = getData(HeaderManpKey)
      ? getData(HeaderManpKey).head_token
      : "";
    const crsBirthAddressInfo = getData(CRSBirthAddressKey);
    const crsDataList = getData(DataKey);

    const CRSDeclareLocationRequest = crsDataList.map((item) => {
      /*
      checkNotax: false = ไม่มีหมายเลขประจำตัวผู้เสียภาษี
      country: (string) = ชื่อประเทศ
      countryId: (string) = CountryId
      notaxId: (int) = choice ที่เลือก เมื่อ ไม่มีหมายเลขประจำตัวผู้เสียภาษี
      notaxId2Text: (string) = เหตุผลอธิบายเพิ่มเติม เมื่อเลือก choice 2
      taxNumber: (string) = หมายเลขประจำตัวผู้เสียภาษี
      */
      return {
        SAffcc_CNT_TaxResidence: item.countryId,
        SAffcc_TIN: item.taxNumber,
        SAffcc_Mrnt_Id: item.notaxId,
        SAffcc_Explain: item.notaxId2Text,
      };
    });

    return {
      head_token: headToken, //token from manp
      f0_city_of_birth: crsBirthAddressInfo.province
        ? crsBirthAddressInfo.provinceNameEn
        : crsBirthAddressInfo.city, //เมืองที่เกิด หรือ จังหวัด
      f0_country_of_birth: crsBirthAddressInfo.country.value, //countryId
      f0_us_citizen: "false", //เป็นบุคคลสหรัฐไหม
      f0_non_us_citizen: "true", //ไม่เป็น บุคคลสหรัฐ ไหม
      f0_crs_tax_detail: JSON.stringify(CRSDeclareLocationRequest),
    };
  };

  const postData = async (postData) => {
    let isSuccess = false;
    const header = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      await GlobalApi.post(
        `${Configs.baseAPIURL03}/form/crs/manp`,
        postData,
        header,
      )
        .then((res) => {
          if (res?.data?.Data?.[0]?.[0]?.IsSuccess !== 1) {
            let mss =
              res.data.Data[0].MsgDesc !== ""
                ? res.data.Data[0].MsgDesc
                : "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
            let title = "เกิดข้อผิดพลาด";
            setModalErrorTitle(title);
            setModalErrorDes(mss);
          } else {
            isSuccess = true;
          }
        })
        .catch((err) => {
          console.log("error post data: ", err);
        });
    } catch (error) {
      console.log("error post data: ", error);
    }
    return isSuccess;
  };

  //Call API: Save Comeback when Edit
  const saveComeBack = async () => {
    let isSuccess = false;
    const head_token = getData(HeaderManpKey)
      ? getData(HeaderManpKey).head_token
      : null;
    const last_stamp = JSON.stringify(await getAllStorage("SUMMARY"));
    const header = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      await GlobalApi.post(
        `${Configs.baseAPIURL03}/form/comeback/manp`,
        {
          head_token: head_token,
          last_stamp: last_stamp,
          stamp_page: "SUMMARY",
        },
        header,
      )
        .then((res) => {
          if (res?.data?.Data?.[0]?.[0]?.IsSuccess === 1) {
            isSuccess = true;
          }
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    } catch (error) {
      console.log("error: ", error);
    }
    return isSuccess;
  };

  useEffect(async () => {
    await checkJumpPage().then((res) => setJumpPage(res));
    // check Edit Page
    await checkEditUrl();
    // ครั้งแรก โหลด ประเทศ ทั้งหมด
    await getCountrys();
    //ถ้ามีการทำก่อนหน้าให้ใช้ค่าก่อนหน้านี้
    const radioChecked = getData(CrsRadioKey);

    if (radioChecked !== "") {
      setValue(radioChecked ? "ใช่" : "ไม่ใช่");
    }
  }, []);

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  useEffect(() => {
    if (getData(EditFlag) == "true") {
      setAlertShow(1);
      sleep(3000).then(() => {
        clearData(EditFlag);
        setAlertShow(0);
      });
    }
    if (getData(DeleteFlag) == "true") {
      setAlertShow(2);
      sleep(3000).then(() => {
        clearData(DeleteFlag);
        setAlertShow(0);
      });
    }
  });

  // check Enable Button
  useEffect(() => {
    const crsData = getData(DataKey);

    if (value) {
      if (value === "ใช่") {
        setIsEnableNextButton(!isEmpty(crsData));
      } else {
        setIsEnableNextButton(true);
      }
    } else {
      setIsEnableNextButton(false);
    }

    if (editUrl) {
      if (!crsData) {
        setIsEnableNextButton(false);
      } else if (crsData.length == 0) {
        setIsEnableNextButton(false);
      } else if (isEqual(getData(CRSData), crsData)) {
        setIsEnableNextButton(false);
      } else {
        setIsEnableNextButton(true);
      }
    }
  }, [value]);

  const handleChange = (value) => {
    setValue(value);
    if (value === "ใช่") {
      storeData(CrsRadioKey, value);
    } else {
      clearData(CrsRadioKey);
    }
  };

  const handleEdit = (value) => {
    storeData(EditKey, value);

    if (editUrl) {
      props.history.push("/crs_form/edit");
    } else {
      props.history.push("/crs_form");
    }
  };

  const handleAddCountry = () => {
    clearData(EditKey);

    if (editUrl) {
      props.history.push("/crs_form/edit");
    } else {
      props.history.push("/crs_form");
    }
  };

  const clickBack = async () => {
    //enableNextButton
    if (enableNextButton && editUrl) {
      setOpenModal(true);
    } else if (editUrl) {
      props.history.goBack();
      // props.history.push("/summary");
    } else {
      props.history.push("/birth_address");
    }
  };

  const handleRedirectToSummary = (isBack) => {
    if (isBack) {
      props.history.goBack();
    }
  };
  const handleRedirectToFirstPage = async (isClickOkButton) => {
    if (isClickOkButton) {
      let data = {};
      // data.head_token = ;
      data.card_id = !isEmpty(checkuserinfo?.cardId)
        ? checkuserinfo?.cardId
        : "";
      data.stamp_page = "1";
      data.error_code = "3005";
      let upd = await updateTracking(data);
      if (upd) {
        props.history.push("/");
      }
    }
  };

  const updateTracking = async (data) => {
    let upd = false;
    if (!isEmpty(data)) {
      try {
        await GlobalApi.post(
          Configs.baseAPIURL03 + "/form/header/update_tracking",
          data,
        )
          .then((res) => {
            let result = res.data.Data[0][0];
            upd = result.MsgDesc.includes("Success") ? true : false;
          })
          .catch((error) => {
            if (!!error.isAxiosError && !error.response) {
              setModalErrorTitle("เกิดข้อผิดพลาด");
              setModalErrorDes("กรุณาทำรายการใหม่อีกครั้ง");
              setIsModalError(true);
            } else {
              let errorMessage = error.response
                ? error.response.data.message
                : "";
              setModalErrorTitle("เกิดข้อผิดพลาด");
              setModalErrorDes(`axios or api error ${errorMessage}`);
              setIsModalError(true);
            }
          });
      } catch (error) {
        setModalErrorTitle("เกิดข้อผิดพลาด");
        setModalErrorDes("กรุณาทำรายการใหม่อีกครั้ง");
        setIsModalError(true);
      }
    }
    return upd;
  };

  return (
    <>
      {jumpPage ? (
        <>
          <Grid className="app-splash-screen"></Grid>
        </>
      ) : (
        <>
          <ThemeProvider theme={theme}>
            <HeaderPage
              title="เปิดบัญชีออนไลน์"
              onChangeLang={(e) => setLang(e)}
              clickBack={(e) => (e ? clickBack() : "")}
            />
            <Loading status={isLoading} />
            {isModalError && (
              <DialogCustoms
                open={isModalError}
                imgModalError
                isModel={setIsModalError}
                title={modalErrorTitle}
                massage={modalErrorDes}
                btnPrimary={"ตกลง"}
              />
            )}
            {openModal && editUrl && (
              <DialogCustoms
                open={openModal}
                isModel={setOpenModal}
                title={"ยกเลิกการแก้ไข"}
                massage={
                  "การแก้ไขยังไม่ได้ถูกบันทึก ท่านต้องการ\nออกจากหน้านี้หรือไม่"
                }
                idBtnPrimary="continue"
                idBtnSecondary="retry"
                btnPrimary={"ออกจากหน้านี้"}
                btnSecondary={"อยู่หน้านี้ต่อ"}
                switchType={(e) => handleRedirectToSummary(e)}
              />
            )}
            <Grid className="background-bg">
              <Grid className="section-consent">
                <Grid className={isMobile ? "box-content-mb" : "box-content"}>
                  <Grid container className="box-content-main" columns={16}>
                    {!isMobile && (
                      <Grid item xs={7} className="box-left">
                        <BoxLeftContent
                          translations={translations?.[lang]?.checkuserinfo}
                          // editUrl={editUrl}
                          clickBack={(e) => clickBack()}
                        />
                      </Grid>
                    )}
                    <Grid
                      item
                      xs={isMobile ? 16 : 9}
                      className={isMobile ? "box-right-mb" : "box-right"}
                    >
                      <Grid className="content">
                        <Grid className="content-main">
                          <Grid
                            className="box-right-content pb-3"
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              height: "100%",
                            }}
                          >
                            <HeaderRight />
                            <Grid sx={{ flexGrow: 1 }}>
                              <ScrollBarComponent
                                content={
                                  <Grid>
                                    <Grid>
                                      <Typography
                                        className={styles.title}
                                        align="left"
                                      >
                                        การแจ้งผู้มีถิ่นที่อยู่ทางภาษีประเทศอื่น{" "}
                                        <u>ยกเว้น</u>ประเทศสหรัฐอเมริกา
                                      </Typography>
                                      <Grid className="input-form" columns={2}>
                                        <Typography className="font-20 text-primary">
                                          ท่านเป็นผู้มีถิ่นที่อยู่ทางภาษีในประเทศอื่นและประเทศไทย{" "}
                                          <u>ยกเว้น</u>ประเทศสหรัฐอเมริกา
                                          ใช่หรือไม่
                                        </Typography>
                                        <Typography
                                          variant="body2"
                                          className="requirement-label"
                                          sx={{
                                            color: "gray",
                                            fontWeight: "normal !important",
                                            mb: 0.25,
                                            fontSize: 20,
                                            paddingTop: 1,
                                          }}
                                        >
                                          (ตอบใช่ โปรดกรอกข้อมูลถิ่นที่อยู่ทางภาษีประเทศอื่นเพิ่มเติม  ตอบไม่ใช่ ระบบจะไม่สามารถทำรายการต่อได้)
                                        </Typography>
                                        <FormControl
                                          style={{
                                            width: "100%",
                                            marginTop: "16px",
                                          }}
                                        >
                                          <RadioGroup
                                            row
                                            aria-labelledby="controlled-radio-buttons-group"
                                            name="radio-buttons-group"
                                            sx={{
                                              display: "flex",
                                              flexDirection: "row",
                                              justifyContent: "space-between",
                                            }}
                                            value={value}
                                          >
                                            {radioList.map((item) => (
                                              <Button
                                                key={item.name}
                                                onClick={() =>
                                                  handleChange(item.name)
                                                }
                                                id={`button_${item.name}`}
                                                variant="outlined"
                                                xs={1}
                                                sx={{
                                                  display: "flex",
                                                  flexDirection: "row",
                                                  justifyContent: "flex-start",
                                                  borderRadius: "10px",
                                                  px: "10px",
                                                  mb: "10px",
                                                  width: "48%",
                                                }}
                                                disabled={!enableRadioButton}
                                              >
                                                <FormControlLabel
                                                  value={item.name}
                                                  disabled={!enableRadioButton}
                                                  control={
                                                    // <Checkbox
                                                    //   id={`radio_${item.name}`}
                                                    //   checked={value === item.name}
                                                    //   defaultChecked={
                                                    //     <AccountBalanceIcon />
                                                    //   }
                                                    //   checkedIcon={
                                                    //     item.name == value ? (
                                                    //       <CheckCircleIcon color="disabled"/>
                                                    //     ) : (
                                                    //       <></>
                                                    //       // <RadioButtonUncheckedIcon color="success"/>
                                                    //     )
                                                    //   }
                                                    // />

                                                    <Radio
                                                      id={`radio_${item.name}`}
                                                      checked={
                                                        value === item.name
                                                      }
                                                      icon={
                                                        <RadioButtonUncheckedIcon
                                                          color={
                                                            enableRadioButton
                                                              ? "primary.main"
                                                              : "disabled"
                                                          }
                                                        />
                                                      }
                                                      checkedIcon={
                                                        item.name == value ? (
                                                          <CheckCircleIcon
                                                            color={
                                                              enableRadioButton
                                                                ? "primary.main"
                                                                : "disabled"
                                                            }
                                                          />
                                                        ) : (
                                                          <RadioButtonUncheckedIcon
                                                            color={
                                                              enableRadioButton
                                                                ? "primary.main"
                                                                : "disabled"
                                                            }
                                                          />
                                                          // <RadioButtonUncheckedIcon color="success"/>
                                                        )
                                                      }
                                                      disabled={
                                                        !enableRadioButton
                                                      }
                                                    />
                                                  }
                                                  label={
                                                    <Typography className="font-weight-bold font-24">
                                                      {item.name}
                                                    </Typography>
                                                  }
                                                />
                                              </Button>
                                            ))}
                                          </RadioGroup>
                                          {/* <RadioGroup
                                        row
                                        aria-labelledby="controlled-radio-buttons-group"
                                        name="radio-buttons-group"
                                        // onChange={handleChange}
                                        className={styles.container}
                                        value={value}
                                      >
                                        {radioList.map((item) => (
                                          <Button
                                            key={item.name}
                                            id={`button_${item.name}`}
                                            disableRipple
                                            // disabled={!enableRadioButton}
                                            variant="outlined"
                                            xs={1}
                                            className={styles.button}
                                          >
                                            <FormControlLabel
                                              value={item.name}
                                              control={
                                                <Radio
                                                  id={`radio_${item.name}`}
                                                  sx={{
                                                    "&.MuiSvgIcon-root": {
                                                      fontSize: 20,
                                                      fontWeight: 100,
                                                      borderWidth: 1,
                                                      color: "text.disabled"
                                                      // color: enableRadioButton ? "primary.main" : "text.disabled",
                                                    },
                                                  }}
                                                  checkedIcon={
                                                    <CheckCircleIcon />
                                                  }
                                                  disableRipple
                                                  // disabled={!enableRadioButton}
                                                />
                                              }
                                              label={
                                                <Typography
                                                  className={styles.label}
                                                >
                                                  {item.name}
                                                </Typography>
                                              }
                                            />
                                          </Button>
                                        ))}
                                      </RadioGroup> */}
                                        </FormControl>
                                        {value === "ใช่" && (
                                          <div id="crs-data-list">
                                            {crsFormData &&
                                              crsFormData.map((item) => (
                                                <Button
                                                  id="selected_country_btn"
                                                  disableRipple
                                                  key={item.countryId}
                                                  variant="text"
                                                  size="large"
                                                  startIcon={<LocationOnIcon />}
                                                  endIcon={
                                                    <KeyboardArrowRightIcon />
                                                  }
                                                  className={
                                                    styles.selectCountryContainer
                                                  }
                                                  style={{
                                                    width: "100%",
                                                    marginTop: "16px",
                                                  }}
                                                  onClick={() =>
                                                    handleEdit(item)
                                                  }
                                                >
                                                  <div
                                                    className={
                                                      styles.selectedCountryTitle
                                                    }
                                                  >
                                                    <Typography
                                                      id="crs-item-title"
                                                      className={styles.detail}
                                                    >
                                                      ประเทศถิ่นที่อยู่ทางภาษี
                                                    </Typography>
                                                    <Typography
                                                      id="crs-item-country"
                                                      className={styles.label}
                                                    >
                                                      {item.country}
                                                    </Typography>
                                                  </div>
                                                </Button>
                                              ))}

                                            {crsFormData.length > 0 &&
                                              crsFormData.length < 4 && (
                                                <Button
                                                  id="add_country_btn"
                                                  disableRipple
                                                  variant="outlined"
                                                  size="large"
                                                  startIcon={<AddIcon />}
                                                  className={
                                                    styles.addCountryContainer
                                                  }
                                                  onClick={() =>
                                                    handleAddCountry()
                                                  }
                                                >
                                                  <Typography
                                                    className={
                                                      styles.addCountryText
                                                    }
                                                  >
                                                    กรุณาระบุประเทศถิ่นที่อยู่ทางภาษี
                                                  </Typography>
                                                </Button>
                                              )}

                                            {crsFormData.length < 1 && (
                                              <Button
                                                id="add_country_btn_required"
                                                disableRipple
                                                variant="contained"
                                                size="large"
                                                startIcon={<AddIcon />}
                                                onClick={() =>
                                                  handleAddCountry()
                                                }
                                                className={
                                                  styles.addCountryContainerRequired
                                                }
                                              >
                                                <Typography
                                                  className={
                                                    styles.addCountryTextRequired
                                                  }
                                                >
                                                  กรุณาระบุประเทศถิ่นที่อยู่ทางภาษี
                                                </Typography>
                                              </Button>
                                            )}
                                          </div>
                                        )}
                                        {isModel && (
                                          <DialogCustoms
                                            open={isModel}
                                            isModel={setIsModel}
                                            imgModalError
                                            title={"ไม่สามารถทำรายการต่อได้"}
                                            massage={
                                              "บริษัทอยู่ระหว่างพัฒนาระบบเพื่อรองรับ\nการเปิดบัญชีของบุคคลผู้มีสัญชาติอเมริกัน\nกรุณาติดต่อ DAOL Contact Center\n0 2351 1800"
                                            }
                                            idBtnPrimary="continue"
                                            idBtnSecondary="retry"
                                            btnPrimary={"ยกเลิกการเปิดบัญชี"}
                                            btnSecondary={"เปิดบัญชีต่อ"}
                                            switchType={(e) =>
                                              handleRedirectToFirstPage(e)
                                            }
                                          />
                                        )}
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                }
                              />
                            </Grid>
                            {/* Grid ปุ่ม: ใช้ marginTop: auto เพื่อดันไปอยู่ล่างสุดเสมอ */}
                            <Grid
                              className={
                                isMobile
                                  ? styles.alertContainerMobile
                                  : styles.alertContainer
                              }
                              sx={{ marginTop: "auto" }}
                            >
                              {alertShow === 0 && (
                                <Button
                                  disableRipple
                                  variant="text"
                                  size="large"
                                  className={alertStyles.placeholder}
                                >
                                  <Typography
                                    id="alert-normal"
                                    className={alertStyles.successText}
                                  >
                                    แก้ไขข้อมูลสำเร็จ
                                  </Typography>
                                </Button>
                              )}
                              {alertShow === 1 && (
                                <Button
                                  disableRipple
                                  variant="text"
                                  size="large"
                                  startIcon={<CheckCircleIcon />}
                                  className={alertStyles.successContainer}
                                >
                                  <Typography
                                    id="alert-edit"
                                    className={alertStyles.successText}
                                  >
                                    แก้ไขข้อมูลสำเร็จ
                                  </Typography>
                                </Button>
                              )}
                              {alertShow === 2 && (
                                <Button
                                  disableRipple
                                  variant="text"
                                  size="large"
                                  startIcon={<CancelIcon />}
                                  className={alertStyles.errorGreyContainer}
                                  style={{ height: "47px" }}
                                >
                                  <Typography
                                    id="alert-delete"
                                    className={alertStyles.errorText}
                                  >
                                    ลบทิ้งแล้ว
                                  </Typography>
                                </Button>
                              )}
                              <Button
                                id="nextPage"
                                disableRipple
                                onClick={handleNextButton}
                                variant="contained"
                                size="large"
                                className="btn-primary"
                                disabled={!enableNextButton}
                                // style={{ height: "47px" }}
                              >
                                <Typography className={styles.btnTextLocation}>
                                  {editUrl ? "บันทึก" : "ถัดไป"}
                                </Typography>
                              </Button>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </ThemeProvider>
        </>
      )}
    </>
  );

  // return (
  //   <>
  //     <ThemeProvider theme={theme}>
  //       <HeaderPage
  //         title={translations?.[lang]?.crs_birth_address?.title}
  //         onChangeLang={(e) => setLang(e)}
  //         clickBack={(e) => (e ? clickBack() : "")}
  //       />
  //       <Loading status={isLoading} />
  //       <Grid className="background-bg">
  //         <Grid className="section-consent">
  //           <Grid className={isMobile ? "box-content-mb" : "box-content"}>
  //             <Grid container className="box-content-main" columns={16}>
  //               {!isMobile && (
  //                 <Grid item xs={7} className="box-left">
  //                   <BoxLeftContent
  //                     translations={translations?.[lang]?.checkuserinfo}
  //                     clickBack={(e) => clickBack()} />
  //                 </Grid>
  //               )}
  //               <Grid
  //                 item
  //                 xs={isMobile ? 16 : 9}
  //                 className={isMobile ? "box-right-mb" : "box-right"}
  //               >
  //                 <Grid className="content">
  //                   <Grid className="content-main">
  //                     <HeaderRight />
  //                     <Grid className="box-right-content">
  //                       <ScrollBarComponent
  //                         content={
  //                           <Grid>
  //                             <Grid>
  //                               <Typography
  //                                 className={styles.title}
  //                                 align="left"
  //                               >
  //                                 การแจ้งผู้มีถิ่นที่อยู่ทางภาษีประเทศอื่น
  //                               </Typography>
  //                               <Grid className="input-form" columns={2}>
  //                                 <Typography className="font-20 text-primary">
  //                                   ท่านเป็นผู้เสียภาษีในประเทศอื่นๆ นอกจากสหรัฐอเมริกา ใช่หรือไม่
  //                                 </Typography>
  //                                 <FormControl
  //                                   style={{ width: "100%", marginTop: "16px" }}
  //                                 >
  //                                   <RadioGroup
  //                                     row
  //                                     aria-labelledby="controlled-radio-buttons-group"
  //                                     name="radio-buttons-group"
  //                                     onChange={handleChange}
  //                                     className={styles.container}
  //                                     value={value}
  //                                   >
  //                                     {radioList.map((item) => (
  //                                       <Button
  //                                         key={item.name}
  //                                         id={`button_${item.name}`}
  //                                         disableRipple
  //                                         variant="outlined"
  //                                         xs={1}
  //                                         className={styles.button}
  //                                       >
  //                                         <FormControlLabel
  //                                           value={item.name}
  //                                           control={
  //                                             <Radio
  //                                               id={`radio_${item.name}`}
  //                                               sx={{
  //                                                 "&.MuiSvgIcon-root": {
  //                                                   fontSize: 20,
  //                                                   fontWeight: 100,
  //                                                   borderWidth: 1,
  //                                                   color: "primary.main",
  //                                                 },
  //                                               }}
  //                                               checkedIcon={
  //                                                 <CheckCircleIcon />
  //                                               }
  //                                               disableRipple
  //                                             />
  //                                           }
  //                                           label={
  //                                             <Typography
  //                                               className={styles.label}
  //                                             >
  //                                               {item.name}
  //                                             </Typography>
  //                                           }
  //                                         />
  //                                       </Button>
  //                                     ))}
  //                                   </RadioGroup>
  //                                 </FormControl>
  //                                 {value === "ใช่" && (
  //                                   <>
  //                                     {crsFormData &&
  //                                       crsFormData.map((item) => (
  //                                         <Button
  //                                           id="selected_country_btn"
  //                                           disableRipple
  //                                           key={item.countryId}
  //                                           variant="text"
  //                                           size="large"
  //                                           startIcon={<LocationOnIcon />}
  //                                           endIcon={<KeyboardArrowRightIcon />}
  //                                           className={
  //                                             styles.selectCountryContainer
  //                                           }
  //                                           style={{
  //                                             width: "100%",
  //                                             marginTop: "16px",
  //                                           }}
  //                                           onClick={() => handleEdit(item)}
  //                                         >
  //                                           <div className={styles.selectedCountryTitle}>
  //                                             <Typography className={styles.detail}>ประเทศถิ่นที่อยู่ทางภาษี</Typography>
  //                                             <Typography className={styles.label}>{item.country}</Typography>
  //                                           </div>
  //                                         </Button>
  //                                       ))}

  //                                     {
  //                                       crsFormData.length > 0 ? (
  //                                         <Button
  //                                           id="add_country_btn"
  //                                           disableRipple
  //                                           variant="outlined"
  //                                           size="large"
  //                                           startIcon={<AddIcon />}
  //                                           className={styles.addCountryContainer}
  //                                           onClick={() => handleAddCountry()}
  //                                         >
  //                                           <Typography
  //                                             className={styles.addCountryText}
  //                                           >
  //                                             กรุณาระบุประเทศถิ่นที่อยู่ทางภาษี
  //                                           </Typography>
  //                                         </Button>
  //                                       )
  //                                       : (
  //                                         <Button
  //                                           id="add_country_btn_required"
  //                                           disableRipple
  //                                           variant="contained"
  //                                           size="large"
  //                                           startIcon={<AddIcon />}
  //                                           onClick={() => handleAddCountry()}
  //                                           className={styles.addCountryContainerRequired}
  //                                         >
  //                                           <Typography
  //                                             className={styles.addCountryTextRequired}
  //                                           >
  //                                             กรุณาระบุประเทศถิ่นที่อยู่ทางภาษี
  //                                           </Typography>
  //                                         </Button>
  //                                       )
  //                                     }

  //                                   </>
  //                                 )}
  //                                 {isModel && (
  //                                   <DialogCustoms
  //                                     open={isModel}
  //                                     isModel={setIsModel}
  //                                     imgModalError
  //                                     title={"ไม่สามารถทำรายการต่อได้"}
  //                                     massage={
  //                                       "บริษัทอยู่ระหว่างพัฒนาระบบเพื่อรองรับ\nการเปิดบัญชีของบุคคลผู้มีสัญชาติอเมริกัน\nกรุณาติดต่อ DAOL Contact Center\n0 2351 1800"
  //                                     }
  //                                     idBtnPrimary="continue"
  //                                     idBtnSecondary="retry"
  //                                     btnPrimary={"ตกลง"}
  //                                     btnSecondary={"ตรวจสอบอีกครั้ง"}
  //                                     switchType={(e) => handleRedirectToFirstPage(e)}
  //                                   />
  //                                 )}
  //                               </Grid>
  //                             </Grid>
  //                           </Grid>
  //                         }
  //                       />
  //                     </Grid>
  //                         <Grid className={isMobile ? styles.alertContainerMobile : styles.alertContainer}>
  //                           {
  //                             (alertShow === 0) && (
  //                               <Button
  //                                 disableRipple
  //                                 variant="text"
  //                                 size="large"
  //                                 className={alertStyles.placeholder}
  //                               >
  //                                 <Typography id="alert-normal" className={alertStyles.successText}>แก้ไขข้อมูลสำเร็จ</Typography>
  //                               </Button>
  //                             )
  //                           }
  //                           {
  //                             (alertShow === 1) && (
  //                               <Button
  //                                 disableRipple
  //                                 variant="text"
  //                                 size="large"
  //                                 startIcon={<CheckCircleIcon />}
  //                                 className={alertStyles.successContainer}
  //                               >
  //                                 <Typography id="alert-edit" className={alertStyles.successText}>แก้ไขข้อมูลสำเร็จ</Typography>
  //                               </Button>
  //                             )
  //                           }
  //                           {
  //                             (alertShow === 2) && (
  //                               <Button
  //                                 disableRipple
  //                                 variant="text"
  //                                 size="large"
  //                                 startIcon={<CancelIcon />}
  //                                 className={alertStyles.errorGreyContainer}
  //                               >
  //                                 <Typography id="alert-delete" className={alertStyles.errorText}>ลบทิ้งแล้ว</Typography>
  //                               </Button>
  //                             )
  //                           }
  //                           <ButtonRight
  //                             id="nextPage"
  //                             text="ถัดไป"
  //                             onNextPage={handleNextButton}
  //                             isDisbled={!enableNextButton}
  //                             />
  //                         </Grid>
  //                   </Grid>
  //                 </Grid>
  //               </Grid>
  //             </Grid>
  //           </Grid>
  //         </Grid>
  //       </Grid>
  //     </ThemeProvider>
  //   </>
  // );
};

export default memo(CRSDeclareLocation);
